export const marketing = {
  foyer: {
    title: 'Foyer',
    type: 'checkbox',
    value: false
  },
  foyerDetails: {
    title: 'Foyer details',
    type: 'simple-text',
    value: ''
  },
  lift: {
    title: 'Lift',
    type: 'checkbox',
    value: false
  },
  liftDetails: {
    title: 'Lift details',
    type: 'simple-text',
    value: ''
  },
  other: {
    title: 'Other marketing',
    type: 'simple-text',
    value: ''
  }
}
